import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth relies solely on the httpOnly `session_token` cookie the backend sets
// (see /auth/session) — withCredentials sends it automatically on same-origin
// requests. We intentionally do NOT read/attach any token from localStorage,
// since that would make the session readable by injected JS (XSS risk).
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const fileUrl = (path) => `${API}/files/${path}`;
